var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2123 7.24108C20.2119 7.24108 21.8329 5.62011 21.8329 3.62054C21.8329 1.62097 20.2119 0 18.2123 0C16.2128 0 14.5918 1.62097 14.5918 3.62054C14.5918 5.62011 16.2128 7.24108 18.2123 7.24108Z",
    fill: "#2563EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98113 4.11133C7.98154 4.11133 6.3606 5.73227 6.3606 7.73187C6.3606 7.88548 6.37126 8.03653 6.38985 8.18512H13.5724C13.591 8.03659 13.6017 7.88548 13.6017 7.73187C13.6017 5.73232 11.9807 4.11133 9.98113 4.11133Z",
    fill: "#2563EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1139 14.2239H24.9072V11.2292C24.9072 10.4931 24.3104 9.89648 23.5745 9.89648H2.54587C1.80978 9.89648 1.21313 10.4932 1.21313 11.2292V26.6678C1.21313 27.4038 1.80978 28.0005 2.54587 28.0005H23.5745C24.3106 28.0005 24.9072 27.4038 24.9072 26.6678V23.6731H17.1139C15.5084 23.6731 14.2022 22.367 14.2022 20.7614V17.1355C14.2022 15.53 15.5083 14.2239 17.1139 14.2239Z",
    fill: "#2563EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.695 16.043H17.1138C16.5108 16.043 16.022 16.5318 16.022 17.1348V20.7607C16.022 21.3637 16.5108 21.8525 17.1138 21.8525H25.695C26.298 21.8525 26.7868 21.3637 26.7868 20.7607V17.1348C26.7868 16.5318 26.2979 16.043 25.695 16.043ZM18.9201 20.2294C18.2123 20.2294 17.6385 19.6556 17.6385 18.9478C17.6385 18.2399 18.2123 17.6662 18.9201 17.6662C19.6279 17.6662 20.2017 18.2399 20.2017 18.9478C20.2017 19.6556 19.6279 20.2294 18.9201 20.2294Z",
    fill: "#2563EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.db2b45d1642229e23f0ae2a53451f024.svg";
export { ForwardRef as ReactComponent };